<div class="col-12 q-light-grey" [ngClass]="[client.LinkedToStage ? 'border-l main' : 'border-l danger']">
  <!--#region bloc détail des conventions du client sélectionné-->
  <input type="checkbox" class="input-button" id="{{client.Ident}}-{{i}}" [(ngModel)]="client.displayed" (ngModelChange)="OnSelectClient(client).subscribe()" />
  <label for="{{client.Ident}}-{{i}}" class="row q-text-l q-bold pt-2 m-0 justify-content-between q-pointer">
    {{client.RaisoCli}}
    <div class="mx-2 q-bold rounded-button q-light-black" style="border-radius: 15px;">{{client?.NbConventions}} Convention(s)</div>
    <div class="mx-2 q-bold rounded-button q-light-black" style="border-radius: 15px;">Total HT : {{client?.MontantConventions | money}}</div>
    <div class="ml-2">
      <i *ngIf="client.loading" class="fas fa-spin fa-spinner fa-pulse q-c-main"></i>
    </div>
    <i class="fas fa-chevron-up chevron ml-auto"></i>
  </label>
  <!--#region bouton création nouvelle convention-->
  <div class="row">
    <div class="col-auto">
      <ng-container *ngIf="client.LinkedToStage else ClientUnlinkedMessage">
        <button class="btn-icon" (click)="AddNewConvention(client)">
          <i class="fas fa-plus-circle q-c-main mr-2"></i>
          <span class="q-text-s">Créer un financement</span>
        </button>
      </ng-container>
      <ng-template #ClientUnlinkedMessage>
        <span class="q-text-s q-c-danger">Client non lié au stage</span>
      </ng-template>
    </div>
  </div>
  <!--#endregion-->

  <div class="accordion-content">
    <ng-container *ngIf="client.DataRetrieved">
      <!--#region liste des conventions-->
      <ng-container *ngFor="let convention of client.Conventions; let i = index">
        <queoval-corps-convention [convention]="convention" [client]="client" [index]="i"></queoval-corps-convention>
      </ng-container>
      <!--#endregion-->
    </ng-container>
  </div>
  <!--#endregion-->
</div>
